import React, { useState } from 'react'
import Select from 'react-select';
import { ExtensiveList } from '../../utils/ExtensiveList';
import { t } from 'i18next'
export const CustomSelectComplex = ({ placeholder = t('SELECT'), isMulti = false, isDisabled = false, isClearable = false, options, value, onChange, name, isSearch = false }) => {

    const [inputValue, setInputValue] = useState('');

    const style = {
        control: (base) => ({
            ...base,
            borderColor: 'var(--gray-500)',
            ":hover": {
                borderColor: 'var(--new-orange)'
            }
        }),
        option: (base, state) => {
            let backgroundColor = 'white';
            let color = 'black';
            let borderColor = 'var(--gray-200)';

            if (state.isSelected) {
                backgroundColor = 'var(--gray-500)';
            } else if (state.isFocused) {
                backgroundColor = 'var(--gray-200)';
                borderColor = 'var(--new-orange)';
            }

            return {
                ...base,
                backgroundColor,
                color,
                cursor: 'pointer',
                borderColor,
                ':active': {
                    backgroundColor: 'var(--gray-500)', // color cuando hacés click
                },
            };
        },
    };

    const theme = (theme) => ({
        ...theme,
        colors: {
            ...theme.colors,
            primary: 'var(--gray-600)',
            primary75: 'var(--new-orange)',
        },
    })

    const placeholderSearch = (<div><i className="fa-solid fa-magnifying-glass color-subtitle p-2"></i>{placeholder}</div>);

    return (
        <Select
            components={{
                ExtensiveList,
                IndicatorSeparator: () => null,
                DropdownIndicator: () => null
            }}
            placeholder={isSearch ? placeholderSearch : placeholder}
            isMulti={isMulti}
            isClearable={isClearable}
            isDisabled={isDisabled}
            options={options}
            value={value}
            name={name}
            noOptionsMessage={() => t('NO_DATA')}
            onChange={onChange}
            theme={theme}
            styles={style}
            {...(isSearch ? { onInputChange: (value) => setInputValue(value) } : {})}
            {...(isSearch ? { menuIsOpen: inputValue.trim() } : {})}
        />
    )
}
